import { useBoundStore } from 'app/store';
import { Notification } from 'shared/ui';
import IconWarning from 'styles/images/icon_warning.svg';

export const Expired = () => {
  const serviceParams = useBoundStore((state) => state['medicalReceipt'].serviceParams);
  return (
    <Notification
      icon={<img src={IconWarning} alt='expired' />}
      title={
        <>
          진료비 세부내역서
          <br />
          열람 기간이 지났어요
        </>
      }
      desc={<>열람 가능한 기간이 지나 조회하실 수 없어요. 추가 발급이 필요한 경우 병원에 문의해 주세요.</>}
      hasBtn={true}
      btnText='돌아가기'
      btnType='secondary'
      handleSubmit={() => {
        window.location.href = serviceParams.redirectUrl;
      }}
    />
  );
};
